import { get, handleResponse } from '../utils/http';

export const getCollectivites = () => {
    return get(`api/napx25cyfrpn645kvr/simulateur/collectivites`)
        .then(handleResponse);
};

export const getCollectivite = (siteInternetCollectivite) => {
    return get(`api/napx25cyfrpn645kvr/simulateur/collectivite/${siteInternetCollectivite}`)
        .then(handleResponse);
};



// WEBPACK FOOTER //
// ./src/api/collectivite.js